import { formatNumber, formatDate, formatDateTime } from "./base_func.js";
import { mapState } from "vuex";

export let BaseTableData = function() {
  return {
    computed: {
      start() {
        return this.pageSize * this.currentPage - this.pageSize;
      },
      fetchParams() {
        let params = {
          format: "table",
          draw: this.lastDraw,
          offset: this.start,
          limit: this.pageSize,
          search: this.searchString,
          ordering: this.sorting
        };

        for (let key in this.filter) {
          if (this.filter[key]) {
            params[key] = this.filter[key];
          }
        }

        return params;
      },
      showClearFilter() {
        let show_filter = false;
        for (let key in this.filter) {
          if (this.filter[key]) {
            show_filter = true;
            break;
          }
        }

        if (this.searchString) {
          show_filter = true;
        }
        return show_filter;
      },

      display_edit_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_owner`
          ) !== -1
        );
      },
      display_delete_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_owner`
          ) !== -1
        );
      },
      display_create_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(`${this.item_type}.${itemtype}_create`) !==
          -1
        );
      },

      display_store_link() {
        return (
          this.permissions.indexOf("store.store_detail_all") !== -1 ||
          this.permissions.indexOf("store.store_detail_owner") !== -1
        );
      },
      display_customer_link() {
        return (
          this.permissions.indexOf("customer.customer_detail_all") !== -1 ||
          this.permissions.indexOf("customer.customer_detail_owner") !== -1
        );
      },
      display_supplier_link() {
        return (
          this.permissions.indexOf("supplier.supplier_detail_all") !== -1 ||
          this.permissions.indexOf("supplier.supplier_detail_owner") !== -1
        );
      },
      display_money_order_link() {
        return (
          this.permissions.indexOf("money_order.moneyorder_detail_all") !==
            -1 ||
          this.permissions.indexOf("money_order.moneyorder_detail_owner") !== -1
        );
      },
      display_account_link() {
        return (
          this.permissions.indexOf("account.account_detail_all") !== -1 ||
          this.permissions.indexOf("account.account_detail_owner") !== -1
        );
      },
      display_user_link() {
        return (
          this.permissions.indexOf("user.user_detail_all") !== -1 ||
          this.permissions.indexOf("user.user_detail_owner") !== -1
        );
      },

      ...mapState([
        "user_id",
        "user_full_name",
        "current_view",
        "current_view_parent",
        "currency",
        "permissions",
        "role",
        "role_display",
        "use_fiscal",
        "company_name",
        "cashes"
      ])
    },
    methods: {
      display_edit_button_by_row(row) {
        let itemtype = this.item_type.replace("_", "");
        if ("can_update" in row) {
          return (
            row.can_update &&
            (this.permissions.indexOf(
              `${this.item_type}.${itemtype}_update_all`
            ) !== -1 ||
              this.permissions.indexOf(
                `${this.item_type}.${itemtype}_update_owner`
              ) !== -1)
          );
        }
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_owner`
          ) !== -1
        );
      },

      display_delete_button_by_row(row) {
        let itemtype = this.item_type.replace("_", "");
        if ("can_delete" in row) {
          return (
            row.can_delete &&
            (this.permissions.indexOf(
              `${this.item_type}.${itemtype}_delete_all`
            ) !== -1 ||
              this.permissions.indexOf(
                `${this.item_type}.${itemtype}_delete_owner`
              ) !== -1)
          );
        }
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_owner`
          ) !== -1
        );
      },

      // Выставляем начальные параметры маршрута
      initialRoute(route) {
        if (route.name === this.item_type + "_detail") {
          const id = route.params.id;
          this.detailView(id);
        } else if (route.name === this.item_type + "_edit") {
          const id = route.params.id;
          this.editView(id);
        } else if (route.name === this.item_type + "_create") {
          this.createView();
        }
      },

      // Загружаем данные для таблицы
      fetchItems() {
        this.loading = true;
        this.lastDraw++;
        this.$http
          .get(this.baseViewUrl, {
            params: this.fetchParams
          })
          .then(result => {
            if (result.data.draw === this.lastDraw) {
              this.data = result.data.results;
              this.totalRecords = result.data.count;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // Actions with showing drawer
      detailView(id) {
        this.item.id = id;
        this.item.action = "detail";
        this.item.show = true;
      },
      editView(id) {
        this.item.id = id;
        this.item.action = "edit";
        this.item.show = true;
      },
      createView() {
        // this.$router.push({name: 'customer_create'});
        this.item.id = null;
        this.item.action = "create";
        this.item.show = true;
      },

      // Another actions
      deleteItem(id) {

          const url = this.baseViewUrl + id + "/";
          this.loading = true;
          this.$http
            .delete(url)
            .then(response => {
              this.fetchItems();
              this.removeModal = false;
            })
            .finally(() => {
              this.loading = false;
            });
      },

      // Изменение номера страницы, размера и сортировки, после чего срабатывае watcher и обновляются данные в таблице
      changePage(page) {
        this.currentPage = page;
      },
      changePageSize(size) {
        this.currentPage = 1;
        this.pageSize = size;
      },
      changeSorting(column) {
        let col = "";

        if (column.key.indexOf("_display")) {
          col = column.key.replace("_display", "");
        } else {
          col = column.key;
        }

        if (column.order === "asc") {
          this.sorting = col;
        } else if (column.order === "desc") {
          this.sorting = "-" + col;
        } else {
          this.sorting = "";
        }
      },

      // Проставление галок в списке
      onSelectChange(selection) {
        this.selected = [];
        for (let row of selection) {
          this.selected.push(row.id);
        }
      },

      // Массовое удаление выбранных документов
      bulkDelete() {
        if (confirm("Вы уверены, что хотите удалить выбранные записи?")) {
          let count = this.selected.length;
          let selected = this.selected.slice();
          this.loading = true;
          for (let id of selected) {
            const url = this.baseViewUrl + id + "/";
            this.$http
              .delete(url)
              .then(response => {
                count--;
                if (count === 0) this.fetchItems();

                this.selected = this.selected.filter(function(
                  value,
                  index,
                  arr
                ) {
                  return value !== id;
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      },

      // Переключения режима "Доп.фильтр"
      toogleFilter(val) {
        this.filterShow = val;

        // Если убираем фильтр - очищаем все поля фильтра
        if (!val) {
          for (let key in this.filter) {
            this.filter[key] = "";
          }
        }
      },

      // Устанавливаем наблюдатели за полями фильтра
      setFilterWatchers() {
        for (let key in this.filter) {
          this.$watch("filter." + key, function(newValue, oldValue) {
            this.fetchItems();
            this.currentPage = 1;
          });
        }
      },

      // Очистка фильтров
      clearFilter() {
        // Очистка общих фильтров и посика
        if (this.searchString) {
          this.searchString = "";
        }
        for (let key in this.filter) {
          if (this.filter[key]) {
            this.filter[key] = "";
          }
        }
      },

      // Форматирование
      formatNumber(number) {
        return formatNumber(number);
      },
      formatDate(date) {
        return formatDate(date);
      },
      formatDateTime(datetime) {
        return formatDateTime(datetime);
      }
    },
    mounted() {
      this.fetchItems();
      this.initialRoute(this.$route);
      this.setFilterWatchers();
    },
    watch: {
      $route(to, from) {
        this.initialRoute(to);
      },

      // Изменение сортировки - перегружаем таблицу
      sorting(to, from) {
        this.fetchItems();
      },

      // Переход на следующую страницу - перегружаем таблицу
      currentPage(to, from) {
        this.fetchItems();
      },

      // Изменение количествва записей на старнице - перегружаем таблицу
      pageSize(to, from) {
        this.fetchItems();
      },

      // Текстовый поиск
      searchString(to, from) {
        this.fetchItems();
        this.currentPage = 1;
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/base/base_table.js